import {ReviewCartProps} from "Agent/AgentForms/Marketing/components/StepCart";
import BasicTable from 'Agent/AgentForms/Marketing/components/Table';

import React from "react";

const ReviewCart = ({cartData, setActiveStep, setUpdatedCart}: ReviewCartProps) => {

    return (
        <div className="review-cart-main">
            <div className="review-cart-table">
                <BasicTable cartData={cartData} setActiveStep={setActiveStep} setUpdatedCart={setUpdatedCart}/>
            </div>
        </div>
    );
}

export default ReviewCart;
